import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthorizationService } from '../../core/services/authorization.service';
import { first } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})

export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = null;
  theme: 'light' | 'dark' = 'dark';
  size: 'compact' | 'normal' = 'normal';
  key: string = environment.sitekey;
  // emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private authService: AuthorizationService
  ) {
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.loginForm = this.formBuilder.group({
      // email: ['', [Validators.pattern(this.emailPattern), Validators.required]],
      email: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.minLength(4), Validators.required]],
      captcha: ['', Validators.required]
    });
  }

  get f() { return this.loginForm.controls }

  onSubmit() {
    this.submitted = false;
    if (this.loginForm.invalid) {
      return
    }

    if (this.loginForm.valid) {
      this.submitted = true;
      this.authService.login(this.loginForm.value)
        .pipe(first())
        .subscribe(
          result => {
            this.router.navigate(['']),
              this.loginForm.reset();
          });
    }
  }
}
